import { Box, Button, Stack, Typography, alpha, useTheme } from "@mui/material";
import type { ReactNode } from "react";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface CheckoutReviewRowProps {
  icon: ReactNode;
  title: string;
  value: string;
  complete: boolean;
  actionLabel?: string;
  onAction?: () => void;
  placeholder?: boolean;
}

/** Linha compacta editável no resumo do checkout. */
export function CheckoutReviewRow({
  icon,
  title,
  value,
  complete,
  actionLabel,
  onAction,
  placeholder = false,
}: CheckoutReviewRowProps) {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={{
        minHeight: 68,
        py: 1,
        px: 0.25,
        borderBottom: "1px solid",
        borderColor: "divider",
        borderStyle: complete ? "solid" : "dashed",
        borderWidth: complete ? "0 0 1px 0" : "0 0 1px 0",
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: 1,
          bgcolor: alpha(theme.palette.primary800.main, 0.08),
          color: "primary800.main",
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          fontSize: "1.1rem",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ ...mt.label, color: "primary800.main", lineHeight: 1.3 }}>
          {title}
        </Typography>
        <Typography
          sx={{
            ...mt.bodySecondary,
            color: placeholder ? "text.secondary" : "text.primary",
            mt: 0.25,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {value}
        </Typography>
      </Box>
      {onAction ? (
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={onAction}
          sx={{
            ...mt.bodySecondary,
            fontWeight: 700,
            minWidth: "auto",
            flexShrink: 0,
            textTransform: "none",
          }}
        >
          {actionLabel ?? (complete ? "Alterar" : "Informar")}
        </Button>
      ) : null}
    </Stack>
  );
}
